import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const NAMES = ['Carlos M.', 'Ana L.', 'Roberto S.', 'María F.', 'Diego P.', 'Fernanda R.', 'Jorge H.', 'Valentina G.', 'Luis A.', 'Sofía T.', 'Andrés V.', 'Camila B.', 'Emilio N.', 'Daniela C.', 'Miguel Á.', 'Paola D.', 'Alejandro K.', 'Isabella M.', 'Sebastián O.', 'Lucía E.'];
const CITIES = ['CDMX', 'Monterrey', 'Guadalajara', 'Puebla', 'Tijuana', 'Mérida', 'Cancún', 'Querétaro', 'León', 'Oaxaca', 'Aguascalientes', 'San Luis Potosí', 'Chihuahua', 'Toluca', 'Morelia'];
function getRandomItem<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
function getRandomInterval() {
  return Math.floor(Math.random() * 20000) + 25000; // 25-45 seconds
}
export function SocialProofToast() {
  const [visible, setVisible] = useState(false);
  const [person, setPerson] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    let showTimeout: ReturnType<typeof setTimeout>;
    let hideTimeout: ReturnType<typeof setTimeout>;
    const showToast = () => {
      setPerson({
        name: getRandomItem(NAMES),
        city: getRandomItem(CITIES)
      });
      setVisible(true);
      hideTimeout = setTimeout(() => {
        setVisible(false);
      }, 4500);
      showTimeout = setTimeout(showToast, getRandomInterval());
    };
    // First toast after 15 seconds
    showTimeout = setTimeout(showToast, 15000);
    return () => {
      clearTimeout(showTimeout);
      clearTimeout(hideTimeout);
    };
  }, []);
  return <AnimatePresence data-id="element-272">
      {visible && <motion.div initial={{
      x: -100,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -100,
      opacity: 0
    }} transition={{
      type: 'spring',
      damping: 20,
      stiffness: 200
    }} className="fixed bottom-6 left-4 z-50 bg-white rounded-xl shadow-2xl border border-charcoal/10 px-5 py-4 max-w-xs" data-id="element-273">
          <div className="flex items-center gap-3" data-id="element-274">
            <div className="w-10 h-10 bg-emerald-100 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-275">
              <span className="text-emerald-600 text-lg" data-id="element-276">✓</span>
            </div>
            <div data-id="element-277">
              <p className="text-sm font-bold text-charcoal leading-tight" data-id="element-278">
                {person.name} de {person.city}
              </p>
              <p className="text-xs text-charcoal/60 mt-0.5" data-id="element-279">
                acaba de unirse al Protocolo 120S
              </p>
            </div>
          </div>
          <div className="mt-2 flex items-center gap-1" data-id="element-280">
            <div className="w-1.5 h-1.5 bg-emerald-500 rounded-full animate-pulse" data-id="element-281" />
            <span className="text-[10px] text-charcoal/40 font-medium" data-id="element-282">
              hace un momento
            </span>
          </div>
        </motion.div>}
    </AnimatePresence>;
}